import { CostChannel } from '@sg/graphql-schema';

import { useQuickAddProductForRestaurantQuery } from '../../graphql/QuickAddProduct.generated';

// ─────────────────────────────────────────────────────────────────────────────

export const useQuickAddRemoteData = (params: Params) => {
  const { baseProductLineageKey, selectedDeliveryAddressId, selectedRestaurantId } = params;

  const costChannel = selectedDeliveryAddressId
    ? CostChannel.DeliveryCostChannel
    : CostChannel.DefaultCostChannel;

  // ─── Remote Data ─────────────────────────────────────────────────────

  const [lineageProductResponse] = useQuickAddProductForRestaurantQuery({
    pause: !baseProductLineageKey || !selectedRestaurantId,
    requestPolicy: 'network-only',
    variables: {
      lineageKey: baseProductLineageKey ?? '',
      restaurantId: selectedRestaurantId ?? '',
      costChannel,
    },
  });

  // ─── Derived ─────────────────────────────────────────────────────────

  const isFetchingProduct = lineageProductResponse.fetching;
  const productForRestaurant =
    lineageProductResponse.data?.productForRestaurantByLineageKey ?? undefined;
  const hasNoProductData = !isFetchingProduct && !productForRestaurant;
  const isUnavailableProduct = hasNoProductData || productForRestaurant?.outOfStock === true;

  // ─────────────────────────────────────────────────────────────────────

  return {
    isFetchingProduct,
    isUnavailableProduct,
    productForRestaurant,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  baseProductLineageKey?: string;
  selectedDeliveryAddressId?: string;
  selectedRestaurantId?: string;
};
